export default __webpack_public_path__ + "static/layout-anatomy-light-22a1bc0b2ffd643c8f98ecc39841ddf7.png";